const colors = {
  background: '#1E2025',
  surface: '#25272C',
  primary: '#3b82f6',
  primaryGlow: 'rgba(59, 130, 246, 0.3)',
  text: '#EAEAEA',
  subtleText: '#8A91A0',
  border: '#3A3D44',
  highlight: '#22c55e',
  highlightGlow: 'rgba(34, 197, 94, 0.25)',
};

const style = {
  colors,
  containerGeneral: {
      width: "100vw",
      height: "100vh",
      position: "fixed",
      top: 0,
      left: 0,
      background: "rgba(10, 11, 13, 0.7)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(10px)",
      zIndex: 1000,
      fontFamily: "'Inter', sans-serif",
  },
  modal: {
      borderRadius: "20px",
      width: "clamp(700px, 85vw, 1100px)",
      maxHeight: "90vh",
      boxSizing: "border-box",
      background: `radial-gradient(circle at top, #2D3039 0%, ${colors.background} 100%)`,
      border: `1px solid ${colors.border}`,
      display: "flex",
      flexDirection: "column",
      position: "relative",
      boxShadow: `0 0 40px rgba(0,0,0,0.5), 0 0 15px ${colors.primaryGlow}`,
      animation: "fadeAndSlideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
      overflow: 'hidden',
  },
  modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: "30px 40px",
      borderBottom: `1px solid ${colors.border}`,
      flexShrink: 0,
  },
  title: {
      fontSize: "28px",
      fontWeight: "700",
      color: colors.text,
      margin: 0,
      letterSpacing: "-0.5px",
  },
  closeBtn: {
      background: colors.surface,
      border: `1px solid ${colors.border}`,
      borderRadius: "50%",
      width: "44px",
      height: "44px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      color: colors.subtleText,
      transition: "all 0.2s ease",
  },
  modalContent: {
      overflowY: 'auto',
      padding: '30px 40px',
      flexGrow: 1,
  },
  detailsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
      gap: "25px",
      marginBottom: "30px",
  },
  infoCard: {
      background: colors.surface,
      borderRadius: '12px',
      padding: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      border: `1px solid ${colors.border}`,
      transition: 'all 0.3s ease',
  },
  infoCardIcon: {
      color: colors.primary,
      background: 'rgba(59, 130, 246, 0.1)',
      width: '44px',
      height: '44px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
  },
  infoCardTitle: {
      fontSize: "14px",
      fontWeight: "600",
      color: colors.subtleText,
      display: 'block',
      marginBottom: "4px",
  },
  infoCardValue: {
      fontSize: "18px",
      fontWeight: "600",
      color: colors.text,
      margin: 0,
  },
  highlightValue: {
      color: colors.highlight,
      textShadow: `0 0 10px ${colors.highlightGlow}`,
  },
  descriptionBox: {
      background: colors.surface,
      borderRadius: '12px',
      padding: '20px',
      border: `1px solid ${colors.border}`,
      marginBottom: '30px',
  },
  descriptionText: {
      fontSize: "15px",
      color: colors.text,
      lineHeight: 1.6,
      margin: 0,
      marginTop: '10px',
  },
  soldProducts: {
      width: "100%",
  },
  soldProductsTitle: {
      fontSize: "22px",
      fontWeight: "700",
      color: colors.text,
      marginBottom: "20px",
  },
  bottomModal: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: '15px',
      padding: "25px 40px",
      borderTop: `1px solid ${colors.border}`,
      background: colors.background,
      flexShrink: 0,
      boxSizing: "border-box"
  },
  statusButton: {
      padding: "12px 24px",
      border: `1px solid ${colors.border}`,
      background: colors.surface,
      color: colors.text,
      borderRadius: "10px",
      fontWeight: "600",
      fontSize: "15px",
      cursor: "pointer",
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: "all 0.2s ease",
  },
  bottomModalButton: {
      padding: "12px 24px",
      border: 'none',
      background: `linear-gradient(45deg, ${colors.primary} 0%, #60a5fa 100%)`,
      color: "#FFFFFF",
      borderRadius: "10px",
      fontWeight: "600",
      fontSize: "15px",
      cursor: "pointer",
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: "all 0.2s ease",
  },
};

export default style;